import {apiInstance, apiInstanceNoToken} from '../helpers';
import { apiFormInstance } from '../helpers';
// import axios from "axios";

// const getHeaders = () => ({
//   headers: { 'Authorization': `Bearer ${window.localStorage.getItem('token')}`}
// });

function create(params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') {

    if (dateOfBirth !== '') {
        params.dateOfBirth = dateOfBirth;
    }

    if (signature !== '') {
        params.signature = signature;
    }

    if (witnessSignature !== '') {
        params.witnessSignature = witnessSignature;
    }

    if (investigatorSignature !== '') {
        params.investigatorSignature = investigatorSignature;
    }

    if (consentFile !== '') {
       params.consentFile = consentFile;

       let formData = new FormData();

       Object.keys(params).map((key) => {
               if (params[key]){
                 formData.append(key, params[key])
               }
             });

       if (params.consentFile[0]) {
        formData.append('consentFile', params.consentFile[0].originFileObj);
       }

      // return axios.post(`${apiUrl()}/consent`, formData, getHeaders()).then(response => {
      //   return response
      // })
      //   .catch(error => {
      //     return Promise.reject(error);
      //   });

       return apiFormInstance.post('/consent', formData)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    } else {
        return apiInstance().post('/consent', params)
            .then(response => {
                return response
            })
            .catch(error => {
                return Promise.reject(error);
            });

    }
}
function createStep2(params) {
  return apiInstance().post('/consent', params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

const createConsentByUrl = url => (params, consentFile='') => {
  if (consentFile !== '') {
    params.consentFile = consentFile;

    let formData = new FormData();

    Object.keys(params).map((key) => {
      if (params[key] && !['consentFile', 'fileList'].includes(key)){
        formData.append(key, params[key])
      }
    });

    if (params.consentFile[0]) {
      formData.append('consentFile', params.consentFile[0].originFileObj);
    }

    return apiInstance().post(url, formData)
      .then(response => {
        return response
      })
      .catch(error => {
        return Promise.reject(error);
      });

  } else {

    return apiInstance().post(url, params)
      .then(response => {
        return response
      })
      .catch(error => {
        return Promise.reject(error);
      });

  }
};

const getConsentByUrlToken = url => token => apiInstanceNoToken.get(`${url}${token}`)
  .then(response => {
    return response
  })
  .catch(error => {
    return Promise.reject(error);
  });

const confirmConsentByUrlToken = url => (token, params, dateOfBirth='', signature='', witnessSignature='', investigatorSignature='', consentFile='') => {

  if (dateOfBirth !== '') {
    params.dateOfBirth = dateOfBirth;
  }

  if (signature !== '') {
    params.signature = signature;
  }

  if (witnessSignature !== '') {
    params.witnessSignature = witnessSignature;
  }

  if (investigatorSignature !== '') {
    params.investigatorSignature = investigatorSignature;
  }

  return apiInstanceNoToken.post(`${url}${token}/confirm`, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const consentServices = {
  create,
  createStep2,
  createLhs: createConsentByUrl('/consent/workflow/lhs'),
  getConsentLhsByToken: getConsentByUrlToken('/consent/workflow/lhs/'),
  confirmConsentLhsByToken: confirmConsentByUrlToken('/consent/workflow/lhs/'),
  createMevo: createConsentByUrl('/consent/workflow/mevo'),
  getConsentMevoByToken: getConsentByUrlToken('/consent/workflow/mevo/'),
  confirmConsentMevoByToken: confirmConsentByUrlToken('/consent/workflow/mevo/'),
  createMevoV2: createConsentByUrl('/consent/workflow/mevo_v2'),
  getConsentMevoV2ByToken: getConsentByUrlToken('/consent/workflow/mevo_v2/'),
  confirmConsentMevoV2oByToken: confirmConsentByUrlToken('/consent/workflow/mevo_v2/'),
};



// WEBPACK FOOTER //
// ./src/services/consent.services.js